import React from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button, Icon, Table } from 'semantic-ui-react';
import findResult from '@/utils/resultsHelper';
import CollectionLabel from '@/collections/components/CollectionLabel';
import { collectionPermissions } from '@/collections/sharing/constants';
import { collectionPerms } from '@/collections/sharing/state/state';
import { datasetPermissions } from '../../sharing/constants';
import { datasetPerms } from '../../sharing/state/state';
import { showRemoveDatasetCollectionConfirmation } from '../actions';

const DatasetCollectionRow = ({
  canManage,
  category,
  code,
  collection,
  name,
  remove,
}) => {
  const intl = useIntl();
  const onDeleteDatasetCollection = React.useCallback(() => {
    remove(category, code, collection.code, name);
  }, [category, code, collection, name]);

  return (
    <Table.Row className="aridhia-message-row">
      <Table.Cell colSpan={2}>
        <div className="flex justify-between bold mt-5 mb-5">
          <CollectionLabel collection={collection} />
          {canManage && (
            <Button
              onClick={onDeleteDatasetCollection}
              icon
              size="mini"
              data-position="left center"
              data-tooltip={intl.formatMessage({ id: 'dataset.collection.remove' })}
            >
              <Icon name="trash alternate" />
            </Button>
          )}
        </div>
      </Table.Cell>
    </Table.Row>
  );
};
const mapStateToProps = ({
  auth: { role },
  datasetUsers: { permissions },
}, { code, collection }) => {
  const datasetUserPermissions = findResult(permissions, 'open', code) || datasetPerms();
  const collectionUserPermissions = collection?.permissions || collectionPerms();
  const canManageCollectionAdmin = role.permissions.collections.datasets;
  const canManageDataOwner = datasetUserPermissions[datasetPermissions.COLLECTIONS]
      && collectionUserPermissions[collectionPermissions.DATASETS];

  return {
    canManage: canManageCollectionAdmin || canManageDataOwner,
  };
};

const mapDispatchToProps = {
  remove: showRemoveDatasetCollectionConfirmation,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetCollectionRow);
